import jsCookies from "js-cookie";

import { ICookieOptions, ICookiesProvider } from "@gamedev-web/gamedev-sdk-core";

export class ClientCookiesProvider implements ICookiesProvider {
  public constructor() {
    if (typeof window === "undefined") {
      throw new Error("BrowserCookiesProvider should only be created in a browser environment");
    }
  }

  public get(key: string) {
    return jsCookies.get(key);
  }

  public getAll() {
    return jsCookies.get();
  }

  public set(key: string, value: string, cookieOptions?: ICookieOptions) {
    const options = this.createCookieOptionsWithDefaults(cookieOptions);

    if (!options.sessionOnly) {
      const maxAgeMilliseconds =
        typeof options.maxAgeMilliseconds === "number"
          ? options.maxAgeMilliseconds
          : 1000 * 60 * 60 * 24 * 45;
      // When no expiration, set to 45 days
      options.expires = options.expires || new Date(new Date().getTime() + maxAgeMilliseconds);
    }

    delete options.maxAgeMilliseconds;
    delete options.categories;
    delete options.essential;

    return jsCookies.set(key, value, options);
  }

  /**
   * IMPORTANT! When deleting a cookie and you're not relying on the default attributes,
   * you must pass the exact same path and domain attributes that were used to set the cookie
   */
  public delete(key: string, cookieOptions?: Pick<ICookieOptions, "path" | "domain">) {
    jsCookies.remove(key, this.createCookieOptionsWithDefaults(cookieOptions));
  }

  private createCookieOptionsWithDefaults(options: ICookieOptions = {}): ICookieOptions {
    return {
      sameSite: "lax",
      path: "/",
      secure: true,
      domain: window.location.hostname,
      ...options,
      essential: true, // TODO: Remove when all cookies are analysed
    };
  }
}
